module.exports = __webpack_public_path__ + "static/poster-1-a5f1246d2db86ceaf89c2278fb5d4e07.png";